// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2BZodpa8xUhx9kffih4Blm"};